import { render, staticRenderFns } from "./OwnerProposalAddressForm.vue?vue&type=template&id=af549ae4&"
import script from "./OwnerProposalAddressForm.vue?vue&type=script&lang=js&"
export * from "./OwnerProposalAddressForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports